/**
 * @file index.jsx
 * @author Rishikesh
 * @date 2024-09-09
 * @description Root file of this app.
 */
import React from "react";
import ReactDOM from "react-dom/client";
import { CssBaseline, GlobalStyles } from "@mui/material";
import { RouterProvider } from "react-router-dom";
import { SnackbarProvider } from "notistack";
import { Provider } from "react-redux";
import "./index.css";
import { router } from "./routes";
import { store } from "./store/store";
import { DrawerProvider } from "./components/context/DrawerContext";
import { ThemeProvider } from "./components/context/ThemeContext";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://4cec27ef08e8a8cb79e55ef339eac224@o4506618696826880.ingest.us.sentry.io/4508277814984704",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, 
  tracePropagationTargets: ["localhost", /^http:\/\/crossroads\.prasanthkumars\.com/],
  // Session Replay
  replaysSessionSampleRate: 0.1, 
  replaysOnErrorSampleRate: 1.0, 
});

const root = ReactDOM.createRoot(document.getElementById("root"));

const globalStyles = {
  a: {
    color: "unset",
    textDecoration: "none",
  },
};

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <SnackbarProvider maxSnack={3}>
            <DrawerProvider>
              <CssBaseline />
              <GlobalStyles styles={globalStyles} />
              <RouterProvider router={router} />
            </DrawerProvider>
          </SnackbarProvider>
        </LocalizationProvider>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);
